import { generateCDNImageUrl, ImageWithFallback } from '@zeptonow/zui';
import { S3_ASSET_URL as CDN_BASE_URL } from '../constant/global';
import { GenerateImageInterface } from './types';

export const generateImage: GenerateImageInterface = ({
  name,
  alt,
  className = '',
  extension = 'svg',
  fullSource = false,
  cdnSource = 'PUBLIC',
  noScale = true,
  fallbackSrc,
}) => {
  const relativePath = fullSource
    ? name.replace(/^\/+/, '')
    : `assets/icons/${name}.${extension}`;

  // S3 + fullSource: `name` is already a complete URL/path — use as-is.
  // PUBLIC: resolve against CDN base (icons/assets).
  const src =
    fullSource && cdnSource === 'S3'
      ? name
      : generateCDNImageUrl({
          relativePath,
          baseUrl: cdnSource === 'PUBLIC' ? CDN_BASE_URL : '',
          noScale,
        });

  return (
    <ImageWithFallback
      src={src}
      alt={alt}
      className={className}
      fallbackSrc={`${CDN_BASE_URL}/${
        fallbackSrc ?? 'assets/fallback-image.svg'
      }`}
    />
  );
};
